import { render } from "./TextLabelThanksMessageUnread.vue?vue&type=template&id=fb6f3cac&scoped=true&ts=true"
import script from "./TextLabelThanksMessageUnread.vue?vue&type=script&lang=ts"
export * from "./TextLabelThanksMessageUnread.vue?vue&type=script&lang=ts"

import "./TextLabelThanksMessageUnread.vue?vue&type=style&index=0&id=fb6f3cac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6f3cac"]])

export default __exports__